import React, { Component } from 'react'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'

export default class ImageLightBox extends Component {
  constructor(props) {
    super(props)

    this.state = {
      photoIndex: props.photoIndex,
      isOpen: true,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.photoIndex !== this.props.photoIndex) {
      this.setState({
        photoIndex: this.props.photoIndex,
      })
    }
  }

  render() {
    const { photoIndex } = this.state

    return (
      <div>
        {this.props.isOpen && (
          <Lightbox
            mainSrc={this.props.images[photoIndex]}
            nextSrc={
              this.props.images[(photoIndex + 1) % this.props.images.length]
            }
            prevSrc={
              this.props.images[
                (photoIndex + this.props.images.length - 1) %
                  this.props.images.length
              ]
            }
            onCloseRequest={() => this.props.setOpen(false)}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex:
                  (photoIndex + this.props.images.length - 1) %
                  this.props.images.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % this.props.images.length,
              })
            }
          />
        )}
      </div>
    )
  }
}
